import _get from 'lodash/get';
import { isEmpty } from 'common/utils/data-utils';

/*
 * ScanDeviceID: [Func] Scan device ID and get JWT token
 * Scan: [Func] Scan ServerTime & SessionID and get JWT token
*/

let hydraModule;
if (process.env.NODE_ENV === 'production') {
  hydraModule = require('../hydra/prd-hydra-1.19.0.24.min.es');
} else {
  hydraModule = require('../hydra/stg-hydra-1.19.0.24.min.es');
}

export const getHydraScanFunc = () => {
  return hydraModule.ScanV2;
};

/*
 * Get hydra data from important requests [getQuote, createOrder, cancelOrder]
 * responses and scan
*/
export const hydraScanFromResponse = (hydraScanFunc, response) => {
  // disable hydra scan in dev env to unblock page loading
  if (!hydraScanFunc) {
    return Promise.resolve();
  }

  const hydraData = _get(response, 'thanosExternalIntimateLoginResponse') || {};
  if (isEmpty(hydraData)) {
    return Promise.reject();
  }

  const { serverTime, sessionID } = hydraData;
  if (!serverTime || !sessionID) {
    return Promise.reject();
  }

  return hydraScanFunc(hydraData);
};
